import React, { Component } from "react";
import PropTypes from "prop-types";
import _ from "lodash";
import { Icon, Input } from "semantic-ui-react";

import { parseStringForSpotifyId, spotifyResourceTypes } from "./utils";

const DEBOUNCE_MS = 1000;
const MAX_WAIT_DEBOUNCE_MS = 1000;

const MyIcon = ({ hasText, isLoading, style, handleClick }) => {
  return (
    <Icon
      onClick={handleClick}
      link
      style={style}
      name={hasText ? "x" : "search"}
    />
  );
};

class SearchInputBox extends Component {
  constructor(props) {
    super(props);
    this.state = { inputString: "", isDebouncing: false };
    this.onInputChange = this.onInputChange.bind(this);
    this.sendSearchRequest = this.sendSearchRequest.bind(this);
    this.sendGetTrackRequest = this.props.sendGetTrackRequest.bind(this);
    this.debouncedSearchRequest = _.debounce(
      this.sendSearchRequest,
      DEBOUNCE_MS,
      { maxWait: MAX_WAIT_DEBOUNCE_MS },
    );
    this.deleteInputText = this.deleteInputText.bind(this);
  }

  onInputChange(event, data) {
    console.log("Edit input. data:");
    console.log(data);
    this.setState({ inputString: data.value });
    this.props.editSearchString(data.value);
    const parsedSpotifyId = parseStringForSpotifyId(data.value);
    console.log("parsedSpotifyId");
    console.log(parsedSpotifyId);
    if (parsedSpotifyId) {
      // User pasted a url or uri to a specific track/album/...
      if (parsedSpotifyId.type === spotifyResourceTypes.TRACK) {
        this.sendGetTrackRequest(parsedSpotifyId.id);
      }
    } else {
      // User is just searching
      this.debouncedSearchRequest();
      this.setState({ isDebouncing: true });
    }
  }

  sendSearchRequest() {
    this.props.submitSearch();
    this.setState({ isDebouncing: false });
  }

  deleteInputText() {
    console.log("deleteInputText");
    this.setState({ inputString: "" });
  }

  render() {
    const showSpinner =
      this.state.inputString.length > 0 &&
      (this.props.isLoading || this.state.isDebouncing);
    return (
      <div>
        <Input
          style={{ margin: ".3em .3em 0 .3em" }}
          size={"huge"}
          input={
            <input
              style={{ backgroundColor: "#777777", borderRadius: "1em" }}
              autoFocus
              value={this.state.inputString}
            />
          }
          fluid
          icon={
            <MyIcon
              hasText={this.state.inputString.length > 0}
              handleClick={this.deleteInputText}
            />
          }
          loading={showSpinner}
          onChange={this.onInputChange}
        />
        <div onClick={this.deleteInputText} />
      </div>
    );
  }
}

SearchInputBox.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  editSearchString: PropTypes.func.isRequired,
  sendGetTrackRequest: PropTypes.func.isRequired,
  submitSearch: PropTypes.func.isRequired,
  inputString: PropTypes.string.isRequired,
};

export default SearchInputBox;
